<template>
  <div :class="{'mask': true, 'leave': leave }" v-if="show" @touchmove.prevent @scroll.prevent>
    <div class="dialog">
      <div class="dialog-body">
        <div class="loading">
          <i class="loading-icon"></i>
        </div>
        <span>{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    text: String
  },
  data () {
    return {
      leave: false
    }
  }
}
</script>
<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  animation: mask-in 0.5s 0.1s both;
}
.mask.leave {
  animation: mask-out 0.5s 0.1s both;
}
.mask.leave>.dialog {
  animation: animate-out 0.5s 0.1s both;
}
.dialog {
  width: 75%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  animation: animate-in 0.5s 0.1s both;
}
.dialog-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loading {
  height: 5em;
  width: 5em;
  background-color: rgba(0, 0, 0, .7);
  border-radius: .5em;
}
.loading-icon {
  display: block;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: 65%;
  background-image: url('../assets/loading.png');
  animation: rotate 1s linear infinite;
}
.dialog-body span {
  margin-top: .3em;
  color: #fff;
  font-size: .9em;
}
@keyframes animate-in {
  0%{ transform:translate(-50%,-70%); opacity: 0 }
	100%{ transform:translate(-50%,-50%); opacity: 1 }
}
@keyframes animate-out {
  0%{ transform:translate(-50%,-50%); opacity: 1 }
	100%{ transform:translate(-50%,-70%); opacity: 0 }
}
@keyframes mask-in {
  0%{ opacity: 0 }
	100%{ opacity: 1 }
}
@keyframes mask-out {
  0%{ opacity: 1 }
	100%{ opacity: 0 }
}
@keyframes rotate{
  from{transform: rotate(0deg)}
  to{transform: rotate(359deg)}
}
</style>